// extracted by mini-css-extract-plugin
export default {"authenticatedShell":"Layout_authenticatedShell__j1A-R"};